if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.buttonHide = this.querySelector('[data-button-hide-bar]');

      this.buttonHide.addEventListener('click', (e) => {
        e.preventDefault();

        this.classList.add('hidden');

        document.documentElement.style.setProperty(
          '--announcement-bar-height',
          `0px`,
        );
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
